import { IDataTableHeader } from '@typings/components';

export const ESTIMATE_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Invoice Number', align: 'left' },
  { label: 'CU name',        align: 'left' },
  { label: 'Invoice Date',   align: 'left' },
  { label: 'Status',         align: 'center' },
  { label: 'Amount',         align: 'center' },
  { label: 'Paid Date',      align: 'center'  },
];

export const INVOICE_HISTORY_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Period',        align: 'left' },
  { label: 'Invoice Total', align: 'right' },
  { label: 'Payment Total', align: 'right' },
];

export const DEFAULT_PRICING_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Description', align: 'left' },
  { label: 'Price',       align: 'center' },
  { label: 'Taxable',     align: 'right' },
];

export const USE_TAX_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'State',     align: 'left' },
  { label: 'Use Tax %', align: 'right' },
];
